import {
  Box,
  Card,
  IconButton,
  Stack,
  Typography,
  Divider,
  Skeleton,
  useMediaQuery,
  useTheme,
  Button
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import SiteIssuesList from "./SiteIssuesList";
import { SITE_ISSUES } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";
import ErrorIcon from "@mui/icons-material/Error";
import { BIRed } from "../../assets/helpers";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Nolocationsites from "./Nolocationsites";
import { useDispatch } from "react-redux";
import {
  setNolocationcount,
  setNoLocationSites,
  setSiteprojects
} from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";

export default function Sitetypes(props) {
  const { loginData, noLocationcount, updateSiteprojects, multiLanguageData } = useSelector(
    (state) => state?.main
  );
  const [noLocationSites, setNolocationsites] = useState(false);
  const [loadingNoLocation, setLoadingNoLocation] = useState(false);
  const [type, setType] = useState("");
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const {
    TEXT_TOP_BUTTON_FOLLOWING = English?.Map?.TEXT_TOP_BUTTON_FOLLOWING,
    TEXT_TOP_BUTTON_MY_SITES = English?.Map?.TEXT_TOP_BUTTON_MY_SITES,
    TEXT_TOP_BUTTON_UNNAMED = English?.Map?.TEXT_TOP_BUTTON_UNNAMED,
    TEXT_ACTIVE_SITES = English?.Map?.TEXT_ACTIVE_SITES,
    TEXT_NO_LOCATION_SITE_INFO = English?.Map?.TEXT_NO_LOCATION_SITE_INFO,
    TEXT_NO_LOCATION_FIRST_TEXT = English?.Map?.TEXT_NO_LOCATION_FIRST_TEXT,
    TEXT_NO_LOCATION_SECOND_TEXT = English?.Map?.TEXT_NO_LOCATION_SECOND_TEXT
  } = multiLanguageData?.Map || {};

  const siteButtons = [
    { label: TEXT_TOP_BUTTON_MY_SITES, value: "My Sites" },
    { label: TEXT_TOP_BUTTON_FOLLOWING, value: "Following" },
    { label: TEXT_TOP_BUTTON_UNNAMED, value: "Unnamed" },
    { label: TEXT_ACTIVE_SITES, value: "Active Sites" }
  ];

  useEffect(() => {
    if (props.filterFlag === true) {
      getNolocationsites();
    }
  }, [props.filterFlag]);

  const getNolocationsites = async () => {
    setLoadingNoLocation(true);
    try {
      const getResponse = await Getrequestcall(
        SITE_ISSUES + `/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        dispatch(setNoLocationSites(getResponse.data?.data ?? []));
        dispatch(setNolocationcount(getResponse.data?.data?.length));
      }
    } catch (error) {
    } finally {
      setLoadingNoLocation(false);
    }
  };

  const onFilterClick = (value) => {
    setType(value === props.activeTab ? "" : value);
    props.onFilterClick(value !== props.activeTab ? value : "");
  };

  useEffect(() => {
    if (updateSiteprojects === true) {
      dispatch(setSiteprojects(false));
      props.onFilterClick(type);
    }
  }, [updateSiteprojects]);

  const openNolocationlist = () => {
    setNolocationsites(!noLocationSites);
  };

  return (
    <>
      <Card
        className="main-content-card"
        sx={{
          position: "absolute",
          mt: 0,
          p: 0.5,
          pl: 0,
          pr: 0,
          width: isMediumScreen ? "100%" : "400px"
        }}>
        <Box sx={{ justifyContent: "flex-end",  display: "flex", p: 1 }}>
          <IconButton
            onClick={() => {
              props?.onClose();
            }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box sx={{ width: isMediumScreen ? "100%" : "400px" }}>
          <Stack
            direction="row"
            spacing={0.5}
            sx={{ p: 0.5 }}
            divider={<Divider orientation="vertical" flexItem />}>
            {siteButtons.map((btn) => (
              <Button
                size="small"
                fullWidth
                sx={{ fontWeight: "normal", p: 1, fontSize: 12 }}
                key={btn.value}
                color={props.activeTab === btn.value ? "primary" : "inherit"}
                variant={props.activeTab === btn.value ? "contained" : "text"}
                onClick={() => onFilterClick(btn.value)}>
                {btn.label}
              </Button>
            ))}
          </Stack>
          {noLocationcount !== 0 && typeof noLocationcount !== "undefined" && (
            <Stack
              className="no-location"
              onClick={() => openNolocationlist()}
              display={"flex"}
              overflow={"scroll"}
              sx={{ scrollbarWidth: "none" }}
              direction={"row"}
              justifyContent={"space-between"}>
              <Stack spacing={1} direction={"row"} sx={{ alignItems: "center" }}>
                <Stack>
                  <ErrorIcon fontSize="small" sx={{ color: BIRed }} />
                </Stack>
                <Typography variant="body2">
                  {TEXT_NO_LOCATION_FIRST_TEXT} {noLocationcount} {TEXT_NO_LOCATION_SECOND_TEXT}
                </Typography>
              </Stack>
              {noLocationSites ? (
                <KeyboardArrowUpIcon sx={{ color: "GrayText" }} />
              ) : (
                <NavigateNextIcon sx={{ color: "GrayText" }} />
              )}
            </Stack>
          )}
          {noLocationSites && noLocationcount !== 0 && (
            <Typography sx={{ p: 1 }} variant="body2">
              {TEXT_NO_LOCATION_SITE_INFO}
            </Typography>
          )}
        </Box>
        <Divider />

        <Box className="main-content-card-list">
          {props?.loading || loadingNoLocation ? (
            <>
              <Stack>
                {[...Array(20)].map((_, index) => (
                  <div key={index}>
                    <Skeleton animation="pulse" height={55} width="100%" />
                  </div>
                ))}
              </Stack>
            </>
          ) : (
            <>
              {noLocationSites === false ? (
                <SiteIssuesList
                  setShowsitedetail={props.setShowsitedetail}
                  setShowSiteCardModal={props?.setShowSiteCardModal}
                  siteList={props?.siteList}
                  setSelectedSiteDetails={props?.setSelectedSiteDetails}
                  showSiteCardModal={props?.showSiteCardModal}
                  setSitetypes={props.setSitetypes}
                  onFilterClick={props.onFilterClick}
                  from={props.from}
                />
              ) : (
                <Nolocationsites
                  setShowSiteCardModal={props?.setShowSiteCardModal}
                  setShowsitedetail={props.setShowsitedetail}
                  noLocationSites={noLocationSites}
                  setNolocationsites={setNolocationsites}
                  getNolocationsites={getNolocationsites}
                  setSitetypes={props.setSitetypes}
                  from={props.from}
                />
              )}
            </>
          )}
        </Box>
      </Card>
    </>
  );
}
